import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AvatarEditor from 'react-avatar-editor';
import Slider from 'rc-slider';
import _actions from '../../actions';
import 'rc-slider/assets/index.css';
import Drag from '../../assets/images/svg/move-arrows.svg';
import Zoom from '../../assets/images/svg/zoom.svg';
import i18n from '../../i18n';
import CloseModal from '../svg/CloseModal';
import LargeLoading from '../svg/LargeLoading';

class ImageCropper extends React.Component {
    static dataURItoBlob(dataURI) {
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = unescape(dataURI.split(',')[1]);
        }
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ia = new Uint8Array(byteString.length);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    }

    constructor(props) {
        super(props);
        this.onImageLoad = this.onImageLoad.bind(this);
        this.handleZoomSlider = this.handleZoomSlider.bind(this);
        this.setEditorRef = this.setEditorRef.bind(this);
        this.state = {
            canCrop: false,
            isLoaded: false,
            scale: 1,
            isCropping: false,
        };
    }

    onImageLoad({ target: img }) {
        const heightRatio = Math.trunc((img.offsetHeight * 100) / this.props.minHeight) / 100;
        const widthRatio = Math.trunc((img.offsetWidth * 100) / this.props.minWidth) / 100;
        const narrow = heightRatio > widthRatio ? widthRatio : heightRatio;
        this.setState({
            isLoaded: true,
            canCrop: true,
            imageToCrop: this.props.crop.originalImage.imagePath,
            narrow,
        });
    }

    onClose = () => {
        if (!this.props.crop.isRecrop) {
            this.props.actions.deleteSingleImageForCrop(this.props.crop.originalImage.id);
        }
        this.props.actions.clearCropModal();
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    setEditorRef = (editor) => { this.editor = editor; return editor; };

    cropImage = () => {
        if (this.state.isCropping === false) {
            this.setState({ isCropping: true });
            const myThis = this;
            let busy = false;
            // eslint-disable-next-line
            const processImage = setInterval(function () {
                if (!busy) {
                    busy = true;
                    const fileCanvas = myThis.editor.getImage();
                    const img = fileCanvas.toDataURL();
                    const file = myThis.constructor.dataURItoBlob(img);
                    const imageId = myThis.props.crop.originalImage.imageId ? myThis.props.crop.originalImage.imageId : myThis.props.crop.originalImage.id;
                    myThis.props.actions.cropImageForCrop(
                        myThis.props.versions.select.projectId,
                        myThis.props.imageType,
                        file,
                        imageId,
                    );
                    clearInterval(processImage);
                }
            }, 100);
        }
    };

    handleZoomSlider = (e) => {
        const scale = parseFloat(e);
        this.setState({ scale });
    };

    render() {
        return (
            <div className="modal-overlay modal-show">
                <div className="modal-header">
                    {/* eslint-disable-next-line */}
                    <a
                        id="close-modal"
                        data-qa="cropper-close-button"
                        className="close-modal"
                        onClick={this.onClose}
                    >
                        <CloseModal />
                    </a>
                </div>
                <div className="modal-content">
                    <h2
                        id="modal-title"
                        data-qa="modal-title"
                        className="modal-title"
                    >
                        {i18n.t('cropper.title')}
                    </h2>
                    <div className="crop-canvas">
                        <p className="crop-message text-center">
                            <img
                                alt=""
                                src={`${Drag}`}
                            />
                            {i18n.t('cropper.drag')}
                        </p>
                        <div className="crop-canvas-inside">
                            <div
                                id="avatar-editor-react-crop"
                                data-qa="avatar-editor-react-crop"
                                className="ReactCrop"
                            >
                                {!this.state.isLoaded
                                    ? (
                                        <>
                                            <div id="loading-page">
                                                <div id="loading-container_loader">
                                                    <LargeLoading />
                                                </div>
                                            </div>
                                            <img
                                                alt=""
                                                style={{ display: 'hidden' }}
                                                className="check-for-load"
                                                onLoad={this.onImageLoad}
                                                src={`${this.props.crop.originalImage?.imagePath}`}
                                            />
                                        </>
                                    )
                                    : (
                                        <div className="cropperWrapper">
                                            <AvatarEditor
                                                ref={this.setEditorRef}
                                                scale={this.state.scale}
                                                image={this.state.imageToCrop}
                                                crossOrigin="anonymous"
                                                height={this.props.cropperHeight}
                                                width={this.props.cropperWidth}
                                                borderRadius={this.props.borderRadius}
                                                border={this.props.cropperBorder}
                                                color={this.props.color}
                                            />
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                    <div id="zoom-slider" className="zoom-slider" data-qa="zoom-slider-wrapper">
                        <img alt="" src={`${Zoom}`} className="min-zoom" />
                        <Slider
                            min={1}
                            max={this.state.narrow ? this.state.narrow : 1} // eslint-disable-line
                            step={0.01}
                            onChange={this.handleZoomSlider}
                            value={this.state.scale ? this.state.scale : 1}
                        />
                        <img alt="" src={`${Zoom}`} className="max-zoom" />
                    </div>
                    <div className="btn-wrap text-center">
                        {/* eslint-disable-next-line */}
                        <a
                            id="cancel-button"
                            data-qa="cancel-crop-button"
                            onClick={this.onClose}
                            className="btn-design-system secondary btn-sm"
                        >
                            {i18n.t('cancel')}
                        </a>
                        {/* eslint-disable-next-line */}
                        <button
                            id="save-button"
                            data-qa="save-crop-button"
                            disabled={!this.state.canCrop}
                            onClick={() => { return this.cropImage(); }}
                            className="btn-design-system primary btn-sm"
                        >
                            {this.state.isCropping ? i18n.t('cropping') : i18n.t('crop')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        versions: state.versions,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageCropper);
